export const FETCH_WALLET_CASHOUTS_DATA = "FETCH_WALLET_CASHOUTS_DATA";
export const FETCH_WALLET_CASHOUTS_SUCCESS = "FETCH_WALLET_CASHOUTS_SUCCESS";
export const FETCH_WALLET_CASHOUTS_FAILURE = "FETCH_WALLET_CASHOUTS_FAILURE";

export const CREATE_WALLET_CASHOUT_DATA = "CREATE_WALLET_CASHOUT_DATA";
export const CREATE_WALLET_CASHOUT_SUCCESS = "CREATE_WALLET_CASHOUT_SUCCESS";
export const CREATE_WALLET_CASHOUT_FAILURE = "CREATE_WALLET_CASHOUT_FAILURE";

export const APPROVE_WALLET_CASHOUT_DATA = "APPROVE_WALLET_CASHOUT_DATA";
export const APPROVE_WALLET_CASHOUT_SUCCESS = "APPROVE_WALLET_CASHOUT_SUCCESS";
export const APPROVE_WALLET_CASHOUT_FAILURE = "APPROVE_WALLET_CASHOUT_FAILURE";

export const REJECT_WALLET_CASHOUT_DATA = "REJECT_WALLET_CASHOUT_DATA";
export const REJECT_WALLET_CASHOUT_SUCCESS = "REJECT_WALLET_CASHOUT_SUCCESS";
export const REJECT_WALLET_CASHOUT_FAILURE = "REJECT_WALLET_CASHOUT_FAILURE";

export const COMPLETE_WALLET_CASHOUT_DATA = "COMPLETE_WALLET_CASHOUT_DATA";
export const COMPLETE_WALLET_CASHOUT_SUCCESS = "COMPLETE_WALLET_CASHOUT_SUCCESS";
export const COMPLETE_WALLET_CASHOUT_FAILURE = "COMPLETE_WALLET_CASHOUT_FAILURE";

export const CANCEL_WALLET_CASHOUT_DATA = "CANCEL_WALLET_CASHOUT_DATA";
export const CANCEL_WALLET_CASHOUT_SUCCESS = "CANCEL_WALLET_CASHOUT_SUCCESS";
export const CANCEL_WALLET_CASHOUT_FAILURE = "CANCEL_WALLET_CASHOUT_FAILURE";

export const RESET_WALLET_CASHOUT_STATE = "RESET_WALLET_CASHOUT_STATE";

